import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./car-ac-repair.css"
export default function CarAcRepair() {
  return (
    <>
      <Helmet>
        <title>
          Car AC Repair & Servicing in Palwal | AutoCare
        </title>

        <meta
          name="description"
          content="Looking for reliable car AC repair in Palwal? AutoCare offers expert AC servicing, gas refill, leak detection, compressor repair, and complete car AC maintenance."
        />

        <link
          rel="canonical"
          href="https://car-repair-mechanic-palwal.netlify.app/services/car-ac-repair"
        />
      </Helmet>

      <section className="servicePage">
        <div className="serviceContent">

          {/* TEXT CONTENT */}
          <div className="textContent">
            <h1>Best Car AC Repair Service in Palwal</h1>

            <p>
              Stay cool and comfortable with <strong>professional car AC repair</strong> at
              <span className="highlight"> AutoCare</span>. We are a trusted
              <strong> car repair service in Palwal</strong>, offering complete
              <span className="highlight"> car AC servicing</span> for all vehicle brands.
            </p>

            <h2>What Does Car AC Repair Include?</h2>
            <p>
              Car AC repair involves inspection, diagnosis, and servicing of AC components such as the compressor,
              condenser, evaporator, cooling gas, and filters to ensure efficient cooling performance.
            </p>

            <h2>Car AC Problems We Fix</h2>
            <ul>
              <li>Low or no cooling</li>
              <li>AC gas leakage & refill</li>
              <li>AC compressor repair or replacement</li>
              <li>Foul smell from AC vents</li>
              <li>AC filter replacement</li>
              <li>Cooling issues during summer</li>
            </ul>

            <h2>Why Choose AutoCare for Car AC Repair?</h2>
            <ul>
              <li>Trusted <span className="highlight">car AC repair service in Palwal</span></li>
              <li>Experienced AC technicians & modern tools</li>
              <li>High-quality refrigerant & genuine parts</li>
              <li>Affordable pricing with transparent service</li>
              <li>Complete <span className="highlight">AutoCare in Palwal</span> for car servicing</li>
            </ul>

            <h2>Car AC Repair Near You</h2>
            <p>
              Searching for the <span className="highlight">best car AC repair near me</span>?
              Trust <strong>AutoCare</strong> for fast, reliable, and professional AC servicing.
            </p>

            <button className="primaryBtn">
              <Link to="/contact">
                Book Car AC Repair Service
              </Link>
            </button>
          </div>

          {/* IMAGE CONTENT */}
          <div className="imageContent">
            <img
              src="/blogimg/CarACThandiHawaNahiDeRaha.webp"
              alt="Car AC Repair & Servicing in Palwal | AutoCare"
            />
          </div>

        </div>
      </section>
    </>
  );
}
